/**
 * @generated SignedSource<<e5c21fffefe38a3c828a06aaddbce9c8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssue$data = {
  readonly " $fragmentSpreads": FragmentRefs<"actionMenu_softwareReleasesVersionDetailIssueList_jiraIssue">;
  readonly " $fragmentType": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssue";
};
export type addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssue$key = {
  readonly " $data"?: addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssue$data;
  readonly " $fragmentSpreads": FragmentRefs<"addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssue",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "actionMenu_softwareReleasesVersionDetailIssueList_jiraIssue"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "3ccc732c38654f19cf9d23f0c776cb28";

export default node;
